import CoreHeaderSubtitle from "./CoreHeaderSubtitle";
import createComponentPreset from "../../../../../../fabrics/createComponentPreset";

import type { CoreHeaderTextComponentProps } from "../../types";

export const createSubtitleFabric = (displayName: string, testId: string) =>
    createComponentPreset<CoreHeaderTextComponentProps>(
        displayName,
        CoreHeaderSubtitle,
        {
            "data-tsid": testId,
        },
    );

export default createSubtitleFabric;
